export default __webpack_public_path__ + "static/media/choicez.02bf0ca2.png";